import React, { Fragment } from 'react';
import { observer } from 'mobx-react';

import { colors } from 'app/variables';
import { localeFormattedPrice } from 'common/utils';
import form from 'modules/ticketPublicPage/stores/tickets/form';
import view from 'modules/ticketPublicPage/stores/tickets/view';
import TicketNumInput from '../common/_numInput';
import {
  Image,
  BuyBlock,
  PriceBlock,
  BuyLabel,
  Title,
  TimeSpan,
  DetailsInfo,
  ImageContainer,
} from './styles/_initial';
import { TicketInlineAlert } from '../common/_inlineAlert';
import ActionButtons from './common/ActionButtons';
import ShareGroup from './common/ShareGroup';
import { InfoText } from './common/Common.styles';
import NoTicketsInfo from './common/NoTicketsInfo';

const Initial = observer(() => {
  const {
    image,
    has_expired: hasExpired,
    status,
    price,
    currency,
    type,
    name,
    description,
    conditions,
    show_share_buttons: showShareButtons,
    tickets_remained: ticketsRemained,
    min_purchases: minPurchases,
  } = view.activeObject;
  const { facility, timespan } = view;
  const { errors } = form;

  const hasAvailableTickets =
    status === 'active' &&
    view.available &&
    !hasExpired &&
    ticketsRemained >= minPurchases;
  const isFree = !Number(price);
  const perTicketLabel =
    type === 'event' ? i18n.gettext('per ticket') : i18n.gettext('per coupon');

  return (
    <BuyBlock>
      <PriceBlock>
        {hasAvailableTickets ? (
          <Fragment>
            {image ? (
              <ImageContainer>
                <Image src={image} />
              </ImageContainer>
            ) : null}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
              }}
            >
              <Title>{name}</Title>
              <TimeSpan>{timespan}</TimeSpan>
            </div>
            <BuyLabel>
              {isFree ? (
                i18n.gettext('Free of charge!')
              ) : (
                <div
                  style={{
                    fontWeight: 600,
                    color: colors.black,
                    fontSize: '1.25rem',
                  }}
                >
                  {localeFormattedPrice(price, {
                    languageCode: facility.languageCode,
                    currencyCode: currency,
                  })}{' '}
                  {perTicketLabel}
                </div>
              )}
              <div style={{ paddingTop: '0.5rem' }}>
                <TicketNumInput />
                {errors.get('num') && (
                  <TicketInlineAlert style={{ marginBottom: '0.5rem' }}>
                    {errors.get('num')}
                  </TicketInlineAlert>
                )}
              </div>
            </BuyLabel>
            <DetailsInfo>
              {description ? (
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontWeight: 600, paddingBottom: '1rem' }}>
                    {i18n.gettext('Description')}
                  </div>
                  <InfoText
                    dangerouslySetInnerHTML={{ __html: description }}
                  ></InfoText>
                </div>
              ) : null}
              {conditions ? (
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontWeight: 600, paddingBottom: '1rem' }}>
                    {i18n.gettext('Conditions')}
                  </div>
                  <InfoText
                    dangerouslySetInnerHTML={{ __html: conditions }}
                  ></InfoText>
                </div>
              ) : null}
              {!!hasAvailableTickets && showShareButtons ? (
                <div>
                  <div style={{ fontWeight: 600, paddingBottom: '1rem' }}>
                    {i18n.gettext('Share this Event')}
                  </div>
                  <ShareGroup />
                </div>
              ) : null}
            </DetailsInfo>
          </Fragment>
        ) : (
          <DetailsInfo>
            <NoTicketsInfo />
          </DetailsInfo>
        )}
      </PriceBlock>
      {hasAvailableTickets ? <ActionButtons /> : null}
    </BuyBlock>
  );
});

export default Initial;
